import React, { useState } from "react";
import { Heading } from "../../components/style/Heading";
import { BoardSelector } from "./BoardSelector";
import { ColorPicker } from "../../components/style/ColorPicker";
import { ContinueButton } from "./ContinueButton";
import { filterByShape } from "../../functions/filterModels";

export const Parametters = ({
  isActive,
  onComplete,
  items,
  activeProduct,
  manager,
  setOverrideStep,
}) => {
  const { state } = manager;
  const boardMaterial = activeProduct.board?.Materijal;
  return (
    <>
      <Heading
        isActive={isActive}
        completed={state.completedParametters}
        completedAttr={"completedParametters"}
        setState={manager.setState}
        onClick={() => setOverrideStep(1)}
        title="Parametri"
      />
      {!state.completed && isActive && (
        <div className="styling-wrap__contents | js-conf-styling-wrap-content">
          {boardMaterial === "Drvo" && (
            <BoardSelector
              title="Debljina ploče"
              items={items.weight}
              activeItem={state.weight}
              onSelect={(value) => manager.selectWeight(value)}
            />
          )}

          {(state.weight || boardMaterial !== "Drvo") && (
            <ColorPicker
              title="Oblik ploče"
              colors={filterByShape(items.shape, activeProduct.oblik)}
              handleColorClick={(val) => manager.selectShape(val)}
              showButton={false}
            />
          )}

          {state.shape && boardMaterial === "Drvo" && (
            <ColorPicker
              title="Oblik ivice"
              colors={items.edge_shape}
              handleColorClick={(val) => manager.selectEdgeShape(val)}
              showButton={false}
            />
          )}

          {state.edge_shape && (
            <ColorPicker
              title={items.cesljano}
              colors={items.cesljano_colors}
              handleColorClick={(val) => manager.selectCesljano(val)}
              setCompleted={(completed) =>
                manager.setState((prev) => ({
                  ...prev,
                  completedParametters: completed,
                }))
              }
              onComplete={onComplete}
            />
          )}

          {state.shape && boardMaterial !== "Drvo" && (
            <ContinueButton
              onClick={() => {
                manager.setState((prev) => ({
                  ...prev,
                  completedParametters: true,
                }));
                onComplete();
              }}
            />
          )}
        </div>
      )}
    </>
  );
};
